import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

const DeleteModal = ({
  onCancel,
  onConfirm,
  isModalVisible,
  modalTitle,
  modalBodyTitle,
}) => {
  return (
    <Modal visible={isModalVisible} onClickBackdrop={onCancel}>
      <div className="modal-header">
        <h5 className="modal-title">{modalTitle}</h5>
        <span role="button" onClick={onCancel} className="close-delete-popup cursor-pointer">
          X
        </span>
      </div>
      <div className="modal-body">
        <p>{modalBodyTitle}</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={onConfirm}>
          Delete
        </button>
      </div>
    </Modal>
  );
};

DeleteModal.defaultProps = {
  modalTitle: '',
  modalBodyTitle: '',
  isModalVisible: false,
};

DeleteModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
  modalBodyTitle: PropTypes.string,
  isModalVisible: PropTypes.bool,
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/Modal/UserModal/DeleteModal.js